<script>
  import {getContext, onMount, onDestroy} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {userApi} from '@/api/user';
  import {drawerUtil} from '@/helper/drawer';
  import {getLocationSearch} from '@/helper/page';
  import {isLogin$} from '@/store/user';
  import {fixLink$} from '@/store/lang';
  import Page from '@/modules/components/Page.svelte';
  import Header from '@/modules/header/Header.svelte';
  import {sd} from '@/da';
  import {subscribeUserStatus} from './streams';
  import {kolInfo$} from './componets/kol-exclusive/stream';
  import {stores} from '@sapper/app';
  import Register from './componets/Register.svelte';
  import UserView2 from '../userView/UserView2.svelte';
  import LeftBanner from '@/modules/login/componets/left-banner/LeftBanner.svelte';
  import KolExclusiveRegister from './componets/kol-exclusive/KolExclusiveRegister.svelte';
  import lang from './RegisterPage.lang';
  import {getRedirectTarget, clearRedirectTarget, isValidRedirectTarget} from '@/modules/header/util';
  import {IP_RESTRICTED_CODE} from '@/emum';

  const LG = getContext('LG');
  const registerUIVersion = 3;
  const {page} = stores();

  // const handleBeforeUnload = () => {
  //   clearRedirectTarget();
  // };

  $: {
    if ($isLogin$) {
      const {connectIdentifier, code} = getLocationSearch();
      if (!connectIdentifier && !code) {
        const {irclickid} = $page.query;
        const params = !!irclickid ? {auth_status: 'Login', click_id: irclickid, click_id_source: 'impact'} : {auth_status: 'Login'};
        sd.pageView(params);
        const target = getRedirectTarget();
        if (target && isValidRedirectTarget(target)) {
          window.location.assign(target);
        } else {
          window.location.assign($fixLink$(PATHS.ACCOUNT_OVERVIEW.pathname));
        }
      }
    }
  }

  onMount(() => {
    // getPublicGeo();
    subscribeUserStatus();
    // if (typeof window !== 'undefined') {
    //   window.addEventListener('beforeunload', handleBeforeUnload);
    // }
  });

  // onDestroy(() => {
  //   if (typeof window !== 'undefined') {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   }
  // });

  async function getPublicGeo() {
    const {referralCode} = getLocationSearch();
    const {reply} = await userApi.getPublicGeoV2({extendInfo: JSON.stringify({referralCode})});
    if (reply && reply.data.code === IP_RESTRICTED_CODE.REGISTER_FORBIDDEN) {
      drawerUtil.launchRegisterTips(LG);
    }
  }
</script>

<style>
  .activity-container {
    height: 100%;
    background: #000;
  }
  @media screen and (max-width: 640px) {
    .activity-container {
      display: none;
    }
  }
</style>

<svelte:head>
  <title>{LG(lang.Title)}</title>
  <meta name="description" content={LG(lang.Description)} />
  <meta name="keywords" content={LG(lang.Keywords)} />
  <style>
    @media screen and (min-width: 640px) {
      html,
      body {
        min-width: 100%;
      }
    }
  </style>
</svelte:head>

<Page>
  <Header isLogin={true} />
  <KolExclusiveRegister />
  {#if !$kolInfo$}
    <UserView2>
      <div class="activity-container df jcc" slot="left">
        <LeftBanner />
      </div>
      <div class="right df jcc f1" slot="right">
        <Register {registerUIVersion} />
      </div>
    </UserView2>
  {/if}
</Page>
